import classnames from 'classnames';
import React, { ReactElement } from 'react';

import * as styles from './GenericCell.module.scss';

export type AllowedColors = 'red' | 'green' | 'grey';

export interface GenericCellProps {
  primary: string | number | ReactElement;
  secondary?: string | number;
  isBold?: boolean;
  secondaryColor?: AllowedColors;
  className?: string;
  alignment?: 'left' | 'right';
  testId?: string;
  columnKey?: string;
}

const GenericCell: React.FC<GenericCellProps> = ({
  primary,
  secondary,
  isBold,
  secondaryColor,
  className,
  alignment = 'right',
  testId,
}) => {
  return (
    <div
      className={classnames(
        styles.GenericCell,
        alignment === 'left' && styles.GenericCell__left,
        alignment === 'right' && styles.GenericCell__right,
        className,
      )}
    >
      <span
        className={classnames(styles.GenericCell__primary, isBold && styles.GenericCell__primary__bold)}
        data-test-id={testId && `${testId}-primary`}
      >
        {primary}
      </span>
      {secondary && (
        <span
          className={classnames(
            styles.GenericCell__secondary,
            isBold && styles.GenericCell__secondary__bold,
            secondaryColor && styles[`GenericCell__secondary__${secondaryColor}`],
          )}
          data-test-id={testId && `${testId}-secondary`}
        >
          {secondary}
        </span>
      )}
    </div>
  );
};

export default GenericCell;
